// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__7JtlT","title":"style_title__3xIEg","text":"style_text__2Hcpr","note":"style_note__1K3su"};